import * as React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { LoginContext } from '../../../App';
import { blindLogin } from '../../../services/b2b-users-apiService';

import './SelectOrg.css';
import { config } from '../../../config';

export default function SelectOrg() {
    // const [loggedOrg, setLoggedOrg] = React.useState('');
    const { loginData, setLoginData, myOrganizations } = React.useContext(LoginContext);

    function normalizeRole(role) {
        return role.startsWith('ROLE_') ? role : `ROLE_${role}`;
    }

    const handleChange = async (event) => {
        if (event.target.value === loginData.loggedOrganizationUuid) {
            return;
        }
        const response = await blindLogin(event.target.value, loginData.accessToken);
        if (response) {
            response.roles = response.roles.map(normalizeRole);
            setLoginData(response);
            //setLoggedOrg(event.target.value);
        } else {
            console.error('Failed to switch organization: ' + event.target.value);
        }
    };

    const truncateString = (str, max = 35) => {
        if (str.length <= max) {
            return str;
        } else {
            return str.slice(0, max) + '...';
        }
    };

    function renderImage(item) {
        return (
            <img
                src={`${config.baseB2B_Images + item.image}`}
                alt={item.organizationName}
                className='b2b-select-organization-image'
            />
        );
    }

    //console.log('SelectOrg: myOrganizations:', myOrganizations);

    return (
        <Box sx={{ minWidth: 120 }} className="b2b-select-organization-container">
            {myOrganizations && myOrganizations.length > 0 && (
                <Select
                    className='b2b-select-organization'
                    value={loginData.loggedOrganizationUuid}
                    onChange={handleChange}
                    renderValue={(selected) => {
                        const item = myOrganizations.find((org) => org.uuid === selected);
                        if (item) {
                            return (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    {renderImage(item)}
                                    {truncateString(item.organizationName)}
                                </Box>
                            );
                        } else {
                            return null;
                        }
                    }}
                >
                    {myOrganizations.map((item) => (
                        <MenuItem key={item.uuid} value={item.uuid}>
                            {renderImage(item)}
                            {item.organizationName}
                        </MenuItem>
                    ))}
                </Select>
            )}
        </Box>
    );
}